
import { addResizeListener, removeResizeListener, ResizableElement } from '@/components/utils/resize-event'
import { toObject } from '@/components/utils/util'
import { computed, defineComponent, nextTick, onBeforeUnmount, onMounted, provide, Ref, ref } from 'vue'
import Bar from './bar.vue'

export default defineComponent({
  name: 'ElScrollbar',
  components: { Bar },

  emits: ['scroll'],

  props: {
    native: {
      type: Boolean,
      default: false
    },
    wrapStyle: {
      type: [String, Array],
      default: ''
    },
    wrapClass: {
      type: [String, Array],
      default: ''
    },
    viewClass: {
      type: [String, Array],
      default: ''
    },
    viewStyle: {
      type: [String, Array],
      default: ''
    },
    noresize: Boolean, // container
    tag: {
      type: String,
      default: 'div'
    }
  },
  setup (props, { emit }) {
    const sizeWidth = ref('0')
    const sizeHeight = ref('0')
    const moveX = ref(0)
    const moveY = ref(0)
    const scrollbar = ref(null)
    const wrap = ref(null)
    const resize = ref(null)

    provide('scrollbar', scrollbar)
    provide('scrollbar-wrap', wrap)

    const getResizableHtmlElement = (refElement: Ref<null> | Ref<ResizableElement>): ResizableElement => {
      return refElement.value as unknown as ResizableElement
    }

    const handleScroll = () => {
      if (!props.native && wrap.value) {
        const element = getResizableHtmlElement(wrap)

        moveY.value = (element.scrollTop * 100) / element.clientHeight
        moveX.value = (element.scrollLeft * 100) / element.clientWidth

        // console.log(`${element.scrollTop + element.clientHeight}/${element.scrollHeight} `)
        const scrollInfo = {
          scrollX: moveX,
          scrollY: moveY,
          scrollTop: element.scrollTop,
          clientHeight: element.clientHeight,
          scrollHeight: element.scrollHeight
        }

        emit('scroll', scrollInfo)
      }
    }

    const update = () => {
      if (!wrap.value) return

      const element = getResizableHtmlElement(wrap)

      const heightPercentage = (element.clientHeight * 100) / element.scrollHeight
      const widthPercentage = (element.clientWidth * 100) / element.scrollWidth

      sizeHeight.value = heightPercentage < 100 ? heightPercentage + '%' : ''
      sizeWidth.value = widthPercentage < 100 ? widthPercentage + '%' : ''
    }

    const style = computed(() => {
      if (Array.isArray(props.wrapStyle)) {
        return toObject(props.wrapStyle)
      }
      return props.wrapStyle
    })

    onMounted(() => {
      if (props.native) return
      nextTick(update)
      if (!props.noresize && resize.value) {
        const element = getResizableHtmlElement(wrap)

        addResizeListener(element, update)
        addEventListener('resize', update)
      }
    })

    onBeforeUnmount(() => {
      if (props.native) return
      if (!props.noresize && resize.value) {
        const element = getResizableHtmlElement(wrap)

        removeResizeListener(element, update)
        removeEventListener('resize', update)
      }
    })

    return {
      moveX,
      moveY,
      sizeWidth,
      sizeHeight,
      style,
      scrollbar,
      wrap,
      resize,
      update,
      handleScroll
    }
  }
})
